import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmployeeFeedbackReport from '../../../FeedbackSessions/EmployeeFeedbackReport';

/**
 * FeedbackViewModal - Modal for viewing feedback assignment results
 *
 * Renders the EmployeeFeedbackReport component directly within the modal.
 *
 * @param {Object} props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Function} props.onClose - Callback when modal closes
 * @param {string} props.assignmentId - The feedback assignment ID to display
 */
const FeedbackViewModal = ({ open, onClose, assignmentId }) => {
  if (!open || !assignmentId) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Feedback Results</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <EmployeeFeedbackReport assignmentId={assignmentId} inModal={true} />
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackViewModal;
